import {
  DataTableSource,
  type DataTablePageOptions,
  type DataTablePageReq,
  type DataTablePageResp,
} from "@carbon6/c6-frontend-design";
import {
  listMyTrainingShareLinks,
  listOrganizationTrainingShareLinks,
} from "@/api/trainingShareLinks";
import { ShareLinkTableRow } from "./ShareLinkTableRow";
import type { ShareLinkScope } from "./shareLinkScope";

const DEFAULT_PAGE_SIZE = 20;

// 공유 링크 목록. 서버가 최신순으로 페이지를 나눠 보낸다. 범위를 바꾸면 1페이지부터 다시 받는다.
export class ShareLinkTableSource extends DataTableSource<ShareLinkTableRow> {
  private scope: ShareLinkScope;

  constructor({ initialScope = "me" }: { initialScope?: ShareLinkScope } = {}) {
    super({
      initialPageSize: DEFAULT_PAGE_SIZE,
      prefetchMode: "paging",
      resolveErrorMessage: () =>
        "공유 링크 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
    });
    this.scope = initialScope;
  }

  setScope(scope: ShareLinkScope): Promise<void> {
    if (scope === this.scope) {
      return Promise.resolve();
    }
    this.scope = scope;
    return this.goToPage(1);
  }

  protected override cacheSignature(): string | null {
    return this.scope;
  }

  protected override async onPage(
    req: DataTablePageReq,
    { signal }: DataTablePageOptions,
  ): Promise<DataTablePageResp<ShareLinkTableRow>> {
    const query = { page: req.page, size: req.size };
    const response =
      this.scope === "all"
        ? await listOrganizationTrainingShareLinks(query, { signal })
        : await listMyTrainingShareLinks(query, { signal });
    return {
      rows: response.items.map((link) => new ShareLinkTableRow(link)),
      total: response.total,
      page: response.page,
      size: response.size,
    };
  }
}
